import { css } from 'linaria';
import { styled } from 'linaria/react';
import { breakpoints } from '../../../../../../media';

export const CardPriceWrapper = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 8px;

	${breakpoints.only.mobile} {
		row-gap: 4px;
	}
`;

export const btnStyles = css`
	max-width: 86px;
`;

export const FlexRow = styled.div`
	grid-auto-flow: column;
	grid-template-columns: max-content;
	display: grid;
	gap: 8px;
	width: 100%;
	align-items: baseline;
`;

export const priceRedline = css`
	position: relative;
	overflow: hidden;
	white-space: nowrap;
	width: fit-content !important;

	&::before {
		position: absolute;
		content: '';
		display: block;
		height: 1px;
		bottom: 0px;
		transform: translateY(-9px);
		width: 100%;
		background-color: var(--secondary-red-primary);
	}
`;

export const WarningWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;
